module.exports = __webpack_public_path__ + "static/img/FJ.b7e648c7.jpg";